import axios from 'axios'

const baseUrl = process.env.REACT_APP_BACKEND_URL

const createJourney = async (journeyData, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
    
    const { originId, destinationId, viaPointsIds, length, date, partOfTrip, operator, note, routingOptions } = journeyData

    const requestData = {
        originId: originId,
        destinationId: destinationId,
        viaPointsIds: viaPointsIds,
        date: date,
        partOfTrip: partOfTrip,
        length: length,
        operator: operator,
        note: note,
        routingOptions: routingOptions,
    }
    
    const response = await axios.post(baseUrl + `/api/journeys/createJourney`, requestData, config)
    
    // console.log(response)
    return response.data
}

const editJourney = async (journeyData, token) => {

  const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
  }
  
  const { journeyId, originId, destinationId, length, date, partOfTrip, operator, note } = journeyData

  const requestData = {
      journeyId: journeyId,
      originId: originId,
      destinationId: destinationId,
      date: date,
      partOfTrip: partOfTrip ? partOfTrip : 'TRIP_UNDEFINED',
      length: length,
      operator: operator,
      note: note,
  }
  
  const response = await axios.post(baseUrl + `/api/journeys/editJourney`, requestData, config)
  
  // console.log(response)
  return response.data
}

const duplicateJourney = async (journeyId, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
  
    const requestData = {
        journeyId: journeyId,
    }
    
    const response = await axios.post(baseUrl + `/api/journeys/duplicateJourney`, requestData, config)
    
    // console.log(response)
    return response.data
  }

const getJourneys = async (token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }

    const response = await axios.get(baseUrl + `/api/journeys/getJourneys`, config)
    // console.log(response.data)
    
    return response.data
}

const deleteJourney = async (journeyId, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  
    const response = await axios.delete(baseUrl + `/api/journeys/deleteJourney` + journeyId, config)
  
    return response.data
  }

const journeyService = {
    createJourney, editJourney, duplicateJourney, getJourneys, deleteJourney
}

export default journeyService